import de from './de.translations.json.js';
import en from './en.translations.json.js';
import es from './es.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import nl from './nl.translations.json.js';
import { uiPaginationTranslationsDe, uiPaginationTranslationsEn, uiPaginationTranslationsEs, uiPaginationTranslationsFr, uiPaginationTranslationsIt, uiPaginationTranslationsNl } from '../ui-pagination/index.js';
import localizationSupportTranslationsEn from '../../mixins/localization-support/en.translations.json.js';
import localizationSupportTranslationsDe from '../../mixins/localization-support/de.translations.json.js';
import localizationSupportTranslationsFr from '../../mixins/localization-support/fr.translations.json.js';
import localizationSupportTranslationsIt from '../../mixins/localization-support/it.translations.json.js';
import localizationSupportTranslationsEs from '../../mixins/localization-support/es.translations.json.js';
import localizationSupportTranslationsNl from '../../mixins/localization-support/nl.translations.json.js';
import { watchlistCreateTranslationsDe, watchlistCreateTranslationsEn, watchlistCreateTranslationsEs, watchlistCreateTranslationsFr, watchlistCreateTranslationsIt, watchlistCreateTranslationsNl } from '../watchlist-create/index.js';
import { watchlistDeleteTranslationsDe, watchlistDeleteTranslationsEn, watchlistDeleteTranslationsEs, watchlistDeleteTranslationsFr, watchlistDeleteTranslationsIt, watchlistDeleteTranslationsNl } from '../watchlist-delete/index.js';
import { watchlistEditTranslationsDe, watchlistEditTranslationsEn, watchlistEditTranslationsEs, watchlistEditTranslationsFr, watchlistEditTranslationsIt, watchlistEditTranslationsNl } from '../watchlist-edit/index.js';

const watchlistListTranslationsDe = {
  ...de,
  ...localizationSupportTranslationsDe,
  ...watchlistCreateTranslationsDe,
  ...watchlistDeleteTranslationsDe,
  ...watchlistEditTranslationsDe,
  ...uiPaginationTranslationsDe
};
const watchlistListTranslationsEn = {
  ...en,
  ...localizationSupportTranslationsEn,
  ...watchlistCreateTranslationsEn,
  ...watchlistDeleteTranslationsEn,
  ...watchlistEditTranslationsEn,
  ...uiPaginationTranslationsEn
};
const watchlistListTranslationsEs = {
  ...es,
  ...localizationSupportTranslationsEs,
  ...watchlistCreateTranslationsEs,
  ...watchlistDeleteTranslationsEs,
  ...watchlistEditTranslationsEs,
  ...uiPaginationTranslationsEs
};
const watchlistListTranslationsFr = {
  ...fr,
  ...localizationSupportTranslationsFr,
  ...watchlistCreateTranslationsFr,
  ...watchlistDeleteTranslationsFr,
  ...watchlistEditTranslationsFr,
  ...uiPaginationTranslationsFr
};
const watchlistListTranslationsIt = {
  ...it,
  ...localizationSupportTranslationsIt,
  ...watchlistCreateTranslationsIt,
  ...watchlistDeleteTranslationsIt,
  ...watchlistEditTranslationsIt,
  ...uiPaginationTranslationsIt
};
const watchlistListTranslationsNl = {
  ...nl,
  ...localizationSupportTranslationsNl,
  ...watchlistCreateTranslationsNl,
  ...watchlistDeleteTranslationsNl,
  ...watchlistEditTranslationsNl,
  ...uiPaginationTranslationsNl
};
const watchlistListTranslationsBundle = {
  de: watchlistListTranslationsDe,
  en: watchlistListTranslationsEn,
  es: watchlistListTranslationsEs,
  fr: watchlistListTranslationsFr,
  it: watchlistListTranslationsIt,
  nl: watchlistListTranslationsNl
};

export { watchlistListTranslationsBundle, watchlistListTranslationsDe, watchlistListTranslationsEn, watchlistListTranslationsEs, watchlistListTranslationsFr, watchlistListTranslationsIt, watchlistListTranslationsNl };
